import { createSelector } from 'reselect'
import { entitySelector, resultsSelector } from 'containers/Entity/selectors'
import cloneDeep from 'lodash/cloneDeep'
import { getMonthDateYearTimestampString } from 'helpers/DateUtil'
import { isClientSelector } from 'containers/Role/Global/selectors'
import T from 'i18n-react'
import { CANCELLED_STATE, DELETED_STATE } from './constants'

const projectWorkflowStateToChangeToSelector = (state) => state.project.workflowDetails.stateToChangeTo

const projectWorkflowDetailsEntitySelector = createSelector(
  entitySelector,
  (entities) => entities.project_workflow_details
    ? entities.project_workflow_details
    : {}
)

const projectWorkflowDetailsSelector = createSelector(
  projectWorkflowDetailsEntitySelector,
  (entity) => {
    if(Object.values(entity)[0]){
      return Object.values(entity)[0]
    } else {
      return {}
    }
  }
)

const projectWorkflowHistorySelector = createSelector(
  projectWorkflowDetailsSelector,
  (projectWorkflowDetails) => {
    if(projectWorkflowDetails.history){
      return projectWorkflowDetails.history
    } else {
      return []
    }
  }
)

const projectWorkflowLifecycleSelector = createSelector(
  projectWorkflowDetailsSelector,
  (projectWorkflowDetails) => {
    if(projectWorkflowDetails.lifecycle){
      return projectWorkflowDetails.lifecycle
    } else {
      return ''
    }
  }
)

const projectWorkflowTransitionsSelector = createSelector(
  projectWorkflowDetailsSelector,
  isClientSelector,
  (projectWorkflowDetails, isClient) => {
    if(projectWorkflowDetails.transitions && projectWorkflowDetails.transitions.length > 0){
      var toReturn = []
      projectWorkflowDetails.transitions.forEach((transition) => {
        if (isClient && [CANCELLED_STATE, DELETED_STATE].includes(transition)) return
        toReturn.push({ value: transition, label: T.translate(`project.lifecycle.milestones.${transition}`)})
      })
      return toReturn
    } else {
      return []
    }
  }
)

const projectWorkflowDetailsLastUpdatedDateSelector = createSelector(
  projectWorkflowHistorySelector,
  (projectWorkflowHistory) => {
    const length = projectWorkflowHistory.length
    if(length > 0){
      return getMonthDateYearTimestampString(new Date(projectWorkflowHistory[length - 1].startDate))
    } else {
      return ''
    }
  }
)

const projectWorkflowDetailsLastUpdatedNameSelector = createSelector(
  projectWorkflowHistorySelector,
  (projectWorkflowHistory) => {
    const length = projectWorkflowHistory.length
    if(length > 0){
      return projectWorkflowHistory[length - 1].createdByUserName
    } else {
      return ''
    }
  }
)

const projectWorkflowIdSelector = createSelector(
  projectWorkflowDetailsSelector,
  (projectWorkflowDetails) => {
    return projectWorkflowDetails.workflowId
  }
)

const projectIdSelector = createSelector(
  projectWorkflowDetailsSelector,
  (projectWorkflowDetails) => {
    return projectWorkflowDetails.projectId
  }
)

const saveDisabledSelector = createSelector(
  projectWorkflowStateToChangeToSelector,
  (stateToChangeTo) => stateToChangeTo === ''
)


export {
  projectWorkflowDetailsSelector,
  projectWorkflowHistorySelector,
  projectWorkflowLifecycleSelector,
  projectWorkflowTransitionsSelector,
  projectWorkflowDetailsLastUpdatedDateSelector,
  projectWorkflowDetailsLastUpdatedNameSelector,
  projectWorkflowStateToChangeToSelector,
  projectWorkflowIdSelector,
  projectIdSelector,
  saveDisabledSelector
}
